import React from 'react';
import Table from '../../components/table';
import { UserManagementSkeleton } from '../../components/Skeleton';
import { SortConfig } from './types';
import { formatAddressForDisplay } from './utils';
import StatusPill from '../StatusPill';

interface GeneralContractorTableProps {
  loading: boolean;
  generalContractors: any[];
  totalItems: number;
  currentPage: number;
  pageSize: number;
  sortConfig: SortConfig;
  searchTerm: string;
  handleSearch: (value: string) => void;
  handleRowClick: (item: any) => void;
  handleSort: (key: string, direction: 'asc' | 'desc' | null) => void;
  setCurrentPage: (page: number) => void;
}

const GeneralContractorTable: React.FC<GeneralContractorTableProps> = ({
  loading,
  generalContractors,
  totalItems,
  currentPage,
  pageSize,
  sortConfig,
  searchTerm,
  handleSearch,
  handleRowClick,
  handleSort,
  setCurrentPage
}) => {
  // Define table columns - simplified to just Name, Address, Active
  const columns = [
    {
      label: 'Name',
      accessor: 'name',
      sortable: true,
      minWidth: '250px'
    },
    {
      label: 'Address',
      accessor: 'address',
      sortable: false,
      minWidth: '300px',
      render: (value: any, row: any) => {
        return formatAddressForDisplay(row);
      }
    },
    {
      label: 'Status',
      accessor: 'status',
      sortable: true,
      minWidth: '120px',
      render: (value: any, row: any) => <StatusPill status={row.active ? 'active' : 'inactive'} />
    },
  ];

  return (
    <>
      {loading ? (
        <UserManagementSkeleton />
      ) : (
        <div className="bg-white rounded-card shadow overflow-hidden p-3 sm:p-4">
          <div className="relative min-h-[300px]">
            {generalContractors.length === 0 ? (
              <div className="flex flex-col items-center justify-center py-12 px-4">
                <svg className="w-12 h-12 text-text-secondary mb-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="1.5" d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                </svg>
                <h3 className="text-subtext font-medium text-text-primary mb-1">No General Contractors Found</h3>
                <p className="text-small text-text-secondary">No general contractors match your search criteria</p>
              </div>
            ) : (
              <div className="overflow-x-auto">
                <Table
                  testId="general-contractors-table"
                  columns={columns}
                  data={generalContractors}
                  totalItems={totalItems}
                  currentPage={currentPage}
                  pageSize={pageSize}
                  onPageChange={setCurrentPage}
                  searchable={true}
                  onSearch={handleSearch}
                  onRowClick={handleRowClick}
                  makeRowClickable={true}
                  onSort={handleSort}
                  sortConfig={sortConfig}
                />
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default GeneralContractorTable;